// extracted by mini-css-extract-plugin
export var hidden = "_pp-1";
export var visible = "_pp-0";